import { topicsData } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '爆': 'bg-primary-500 text-white',
  '热': 'bg-accent-500 text-white',
  '新': 'bg-accent-400 text-white',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1200px]">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-3">
            热议话题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">热议话题</h2>
          <p className="mt-2 text-sm text-foreground-600">当前最火爆的吃瓜话题都在这里</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className="group flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                <i className={`${topic.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5">
                  <span className="text-sm font-semibold text-foreground-800 truncate">{topic.name}</span>
                  {topic.tag && (
                    <span className={`flex-shrink-0 px-1.5 py-0.5 text-[10px] font-bold rounded ${tagColors[topic.tag] || ''}`}>
                      {topic.tag}
                    </span>
                  )}
                </div>
                <span className="text-xs text-foreground-500">{topic.heat} 热度</span>
              </div>
              <span className="flex-shrink-0 text-foreground-400 group-hover:text-primary-500 transition-colors">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}